import React from "react";
import { useTranslation } from "react-i18next";
import { AnnouncementEditor } from "../features/announcements/Editor";
import { withRestaurantId } from "../shared/components/layout";

const AnnouncementEditorWithId = withRestaurantId(AnnouncementEditor);

const AnnouncementEditorPage: React.FC = () => {
  const { t } = useTranslation();

  return <AnnouncementEditorWithId />;
};

export default AnnouncementEditorPage;
